import { Component } from '@angular/core';

@Component({
  selector: 'app-diy-starter',
  templateUrl: './diy-starter.component.html',
  styleUrls: ['./diy-starter.component.scss']
})
export class DiyStarterComponent {

}
